module.exports = __webpack_public_path__ + "img/icon-instagram.8d00752e.svg";